import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt";
import "datatables.net-responsive-dt";
import $ from "jquery";
import { Link } from "react-router-dom";
import api from "../../../config/URL";
// import DeleteModel from "../../../components/admin/DeleteModel";
import { PiPlusSquareFill } from "react-icons/pi";

const PayoutTransaction = () => {
  const tableRef = useRef(null);
  const [datas, setDatas] = useState([]);
  const [minimumAmount, setMinimumAmount] = useState({});
  const [loading, setLoading] = useState(true);

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      return;
    }
    $(tableRef.current).DataTable({
      columnDefs: [{ orderable: false, targets: -1 }],
    });
  };

  useEffect(() => {
    if (!loading) {
      initializeDataTable();
    }
    return () => {
      destroyDataTable();
    };
  }, [loading]);

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
  };

  const refreshData = async () => {
    destroyDataTable();
    setLoading(true);
    try {
      const response = await api.get("/affiliate/payout/transactions");
      setDatas(response.data.data.affiliate);
      setMinimumAmount(response.data.data.accountDetails);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
    setLoading(false);
    initializeDataTable();
  };

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <section className="px-4">
      <div className="card shadow border-0 mb-2 top-header">
        <div className="container-fluid py-1">
          <div className="row align-items-center">
            <div className="col p-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <h3 className="mb-0 ls-tight">Payout Transaction</h3>
                  (Minimum Withdrawal Amount :{" "}
                  {minimumAmount?.minimum_withdrawal
                    ? new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      maximumFractionDigits: 0,
                    }).format(minimumAmount?.minimum_withdrawal)
                    : "0"}
                  )
                </div>
                <div className="d-flex justify-content-end">
                  <div className="d-flex justify-content-end">
                    {minimumAmount?.minimum_withdrawal <
                      minimumAmount?.outstanding_balance ? (
                      <Link
                        to="/payout-transaction/add"
                        state={{
                          outstanding_balance:
                            minimumAmount?.outstanding_balance,
                        }}
                      >
                        <button className="btn btn-sm btn-button shadow-none border-none py-3">
                          <PiPlusSquareFill size={20} /> Request Payout
                        </button>
                      </Link>
                    ) : (
                      <button
                        className="btn btn-sm btn-button shadow-none border-none py-3 disabled-button"
                        disabled
                      >
                        <PiPlusSquareFill size={20} /> Request Payout
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container card shadow border-0"
        style={{ minHeight: "80vh" }}
      >
        {loading ? (
          <div className="loader-container">
            <div className="loader">
              <svg viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="32"></circle>
              </svg>
            </div>
          </div>
        ) : (
          <div className="table-responsive p-2">
            <table
              ref={tableRef}
              className="display table nowrap"
              style={{ width: "100%" }}
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ whiteSpace: "nowrap" }}>
                    S.NO
                  </th>
                  <th className="text-center">Amount</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Request At</th>
                  <th className="text-center">Paid At</th>
                  <th className="text-center">Payment Mode</th>
                  <th className="text-center">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {datas?.map((data, index) => (
                  <tr key={data.id}>
                    <td className="text-center align-middle">{index + 1}</td>
                    <td className="text-center">
                      {data?.amount
                        ? new Intl.NumberFormat("en-IN", {
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        }).format(data.amount)
                        : "-"}
                    </td>
                    <td className="">
                      {data?.status === "approved" && (
                        <span className="badge badge-success ms-2">
                          Approved
                        </span>
                      )}
                      {data?.status === "rejected" && (
                        <span className="badge badge-danger ms-2">
                          Rejected
                        </span>
                      )}
                      {data?.status === "pending" && (
                        <span className="badge badge-warning ms-2">
                          Pending
                        </span>
                      )}
                    </td>
                    <td className="text-center ms-2">
                      {data?.requested_at
                        ? data.requested_at.split(" ")[0]
                        : "-"}
                    </td>
                    <td className="text-center ms-2">
                      {data?.paid_at ? data.paid_at.split(" ")[0] : "-"}
                    </td>
                    <td className="text-center ms-2">
                      {data?.payment_mode || "-"}
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center">
                        <Link to={`/payout-transaction/view/${data.id}`}>
                          <button className="button-btn btn-sm m-2">
                            View
                          </button>
                        </Link>
                        {data.status !== "approved" && (
                          <Link
                            to={`/payout-transaction/edit/${data.id}`}
                            state={{
                              outstanding_balance:
                                minimumAmount?.outstanding_balance,
                            }}
                          >
                            <button className="button-btn btn-sm m-2">
                              Edit
                            </button>
                          </Link>
                        )}
                        {/* <DeleteModel
                          onSuccess={refreshData}
                          path={`/admin/payout-transaction/delete/${data.id}`}
                          style={{ display: "inline-block" }}
                        /> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default PayoutTransaction;
